import { validateNumber, validateString } from 'avilatek-utils';
import { TPayablePaymentForm } from '../../models';

export function validatePayablePaymentForm({
  bank,
  paymentmethod,
  amount,
  reference,
  image,
  orderProductsIds,
  changetype,
  paymentdate,
}: Partial<TPayablePaymentForm>): string {
  if (!validateString(paymentmethod) && paymentmethod === '') {
    return 'El método de pago es inválido';
  }
  if (!validateString(bank) || bank === '') {
    return 'El banco es inválido';
  }
  if (!validateNumber(amount) && amount <= 0) {
    return 'El monto es inválido';
  }
  if (
    paymentmethod !== 'Zelle' &&
    (!validateNumber(changetype) || changetype <= 0)
  ) {
    return 'El tipo de cambio es inválido';
  }
  if (!validateNumber(reference) || reference <= 0) {
    return 'La referencia es inválida';
  }

  if (!validateString(paymentdate) || paymentdate === '') {
    return 'La fecha de pago es inválida';
  }
  if (!validateString(image) && image !== '') {
    return 'La url de la imagen es inválida';
  }
  if (orderProductsIds.length === 0) {
    return 'No hay productos en la orden';
  }
  return '';
}
